<div class="card">
    <div class="header" style="height: 40px;">
      <h5 class="title" id="exampleabel" style="color:#a5a8ad; float:left;">Agregar Tarea</h5>
      <button type="button" class="btn btn-danger btn-round"  style="float: right;" (click)="cerrar()">Cerrar</button>

    </div>
    <form method="POST" #addForm="ngForm" (ngSubmit)="onSubmit(addForm)">
      <div class="body">
      <div class="form-group" style="float:right; margin:-10px;">
        <label><i class="fa fa-asterisk" style="color:#D64968; margin:5px; font-size:10px;"></i> Campos Obligatorios </label>
      </div>
      <div class="form-group">
          <label class="form-label">Nombre de la Tarea</label><label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
          <input class="form-control" id="actividad" required [(ngModel)]="task.titulo" name="titulo">
      </div>
      <div class="form-group">
        <label class="form-label">Tipo de Fecha</label><label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
        <div class="selectgroup2 w-100">
          <label class="selectgroup-item">
            <input type="radio" name="fecha_form" value="0" id="fecha_form" class="selectgroup-input"  (click)="fecha_uno()" checked>
            <span class="selectgroup-button">Fecha única</span>
          </label>
          <label class="selectgroup-item">
            <input type="radio" name="fecha_form" value="1" id="fecha_form2" class="selectgroup-input"  (click)="fecha_dos()" [(ngModel)]="task.tipo">
            <span class="selectgroup-button">Fecha con Intervalo</span>
          </label>
         

        </div>
      </div>

     
      <div id="campo_fecha" style="display: block;">
        <label>Fecha</label>
        <label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>

        <div class="form-group">
          <div class="input-group">
            <input class="form-control" placeholder="yyyy-mm-dd" autocomplete="off"
                   name="dp" [(ngModel)]="model"  ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar"  (click)="d.toggle()" type="button">
                <i class="fa fa-calendar" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        
        

        <div class="form-group"  *ngIf="tipo_fecha">
          <label style="    width: 130px;">Fecha de termino</label> <label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label><br>
          <div class="input-group">
            <input class="form-control" placeholder="yyyy-mm-dd" autocomplete="off"
                   name="dp2" [(ngModel)]="model2"  ngbDatepicker #d2="ngbDatepicker" (click)="d2.toggle()">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar"  (click)="d2.toggle()" type="button">
                <i class="fa fa-calendar" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        


        
        <div class="row" *ngIf="!tipo_fecha"> 
          <div class="col-md-6">
            <label style="    width: 120px;">Hora de Inicio</label>
             <label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
            <ngb-timepicker name="algo" [(ngModel)]="time" [meridian]="true"></ngb-timepicker>
            <hr>
            <!-- <pre>Selected time: {{time.hour}} {{time.minute}}</pre> -->
            </div>
            <div class="col-md-6">
              <label style="    width: 120px;">Hora de Termino</label>
               <label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
              <ngb-timepicker name="algo2" [(ngModel)]="time2" [meridian]="true"></ngb-timepicker>
              <hr>
            <!-- <pre>Selected time: {{time.hour}} {{time.minute}}</pre> -->
          </div>
        </div>



      </div>
      <div id="campo_fecha_intervalo" style="display: none;">
        <label>Fechas</label><label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
        <input type="text" id="demo-3_1" value="05/17/2020 - 05/17/2020" class="form-control form-control-sm">
        <input type="text" id="result-3" style="display: none;">

      </div>
      <div class="form-group">
        <label class="form-label">Comentario</label>
        <div class="form-group">
          <div class="col-sm-12 col-md-12">
            <ckeditor data="" [(ngModel)]="task.comentario"  name="comentario" type="inline"></ckeditor>
            <!-- <textarea  cols="10" rows="5" class="form-control" [(ngModel)]="task.comentario"></textarea> -->
            <!-- <div [froalaEditor]='options'  [(froalaModel)]="task.comentario">
              
            </div> -->
          </div>
        </div>
      </div>

      <div class="form-group">
          <label class="form-label">Importancia</label><label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
          <div class="selectgroup2 w-100">
            <label class="selectgroup-item">
              <input type="radio" name="importancia" value="1" class="selectgroup-input"  [(ngModel)]="task.importancia">
              <span class="selectgroup-button">Baja</span>
            </label>
            <label class="selectgroup-item">
              <input type="radio" name="importancia" value="2" class="selectgroup-input"  [(ngModel)]="task.importancia" checked>
              <span class="selectgroup-button">Media</span>
            </label>
            <label class="selectgroup-item">
              <input type="radio" name="importancia" value="3" class="selectgroup-input"  [(ngModel)]="task.importancia">
              <span class="selectgroup-button">Alta</span>
            </label>

          </div>
        </div>

       <div class="form-group">
          <label class="form-label">Estatus</label><label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
          <div class="selectgroup w-100">
           
            <label class="selectgroup-item" *ngFor="let list of listas?.estatus">                
              <input type="radio" name="status" [value]="list.id_estatus" class="selectgroup-input"  [(ngModel)]="task.estatus">                
              <span class="selectgroup-button">{{list.estatus}}</span>              
            </label>
          </div>
          <div *ngIf="!aestatus">
            <a  class="text-right add_estatus_btn" id="add_estatus_btn" style="float: right; width: 350px; display: block; cursor: pointer;" (click)="campo_estatus()" ><i class="fa fa-tags"></i> Agregar Estatus</a>
          </div>
        <div *ngIf="aestatus"> 
          <button type="button" class="btn btn-danger btn-round" style="float: right;" (click)="cerrar_campo_estatus()">Cerrar Estatus</button>
          <app-estatus (otrafuncion)="usuarios_estatus(cat)"></app-estatus>
        </div>
      
      </div>

        


      <div class="form-group">
        <label class=" mt-2">
          <input type="checkbox" id="privada" name="custom-switch-checkbox" class="custom-switch-input color"  [(ngModel)]="task.privado">
          <span class="custom-switch-indicator color" style=""></span>
          <span class="custom-switch-description ">¿Es una Tarea Privada?</span>
        </label>
      </div>

    <div class="form-group">
      <label class="form-label">Usuarios</label><label style="color:#D64968; margin:5px; font-size:10px;"><i class="fa fa-asterisk" style="color:#D64968;"></i></label>
      
      <select class="selectpicker form-control" multiple  [(ngModel)]="task.usuarios" name="users" data-style="btn-info" data-size="6" data-show-subtext="true" data-live-search="true" title="Seleccia a los usuarios" required>
        <option *ngFor="let agrega of listas?.usuarios" value="{{agrega.id_us}}" >{{agrega.name}} {{agrega.last_name}}</option>
      </select>
        

    </div>

     <div class="form-group" id="color_notas">
        <label class="form-label">Color</label>
        <div class="col-8" id="">
            <input   type="color" id="color" [(value)]="task.color" [(ngModel)]="task.color" name="color" class="form-control" />
        </div>
      </div>

    
    <h4 id="msng_error" style="font-size: 13px;"></h4>
    </div>
    <div class="modal-footer">

      <button class="buttonload btn btn-primary" style="display: none;">
    <i class="fa fa-spinner fa-spin"></i>Cargando
  </button>

      <button type="submit" id="guardar_tarea" class="btn btn-primary" [disabled]="!addForm.form.valid || loading">
        <i class="fa " aria-hidden="true" [ngClass]="{ 'fa-save':!loading, ' fa-refresh fa-spin':loading }"></i>
        Guardar</button>
    </div>
  </form>
  </div>
